import * as React from 'react';

import styles from './bold-label.module.css';

type Props = {
    children?: React.ReactNode;
    as?: string;
};

export function BoldLabel(props: Props) {
    const {children, as = 'label'} = props;
    const Tag = as;

    // @ts-expect-error
    return <Tag className={styles['bold-label']}>{children}</Tag>;
}
